/**
 * Toast utility functions
 *
 * Provides pre-configured toast wrappers for consistent notifications
 * throughout the storefront.
 */

import { toast } from "@/hooks/use-toast"

export function showSuccess(title: string, description?: string) {
  return toast({
    title,
    description,
    duration: 2500,
  })
}

export function showError(title: string, description?: string) {
  return toast({
    title,
    description,
    variant: "destructive",
  })
}

export function showWarning(title: string, description?: string) {
  return toast({
    title,
    description,
  })
}

export function showInfo(title: string, description?: string) {
  return toast({
    title,
    description,
  })
}
